import { render, staticRenderFns } from "./EmarPatientVitalsV1.vue?vue&type=template&id=54c1bd82&scoped=true&"
import script from "./EmarPatientVitalsV1.vue?vue&type=script&lang=js&"
export * from "./EmarPatientVitalsV1.vue?vue&type=script&lang=js&"
import style0 from "./EmarPatientVitalsV1.vue?vue&type=style&index=0&id=54c1bd82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1bd82",
  null
  
)

export default component.exports